import styled from "styled-components"
import { Card } from "antd"

export const Column = styled(Card)`
  cursor: pointer;
  transition: border-color 200ms;
  box-sizing: content-box;
  border-color: transparent;
  position: relative;
  outline: none;

  :has(.sticky-header:hover) {
    cursor: pointer;
    border-color: #ececec;
  }

  .ant-card-body {
    padding: 0;
  }

  :active {
    background-color: #ececec;
  }

  :focus {
    background-color: red;
  }
`

export const yDivide = {
  marginTop: "0.5rem",
  marginBottom: "0.5rem",
}

export const addTaskButton = {
  width: "100%",
  position: "sticky",
  top: "1px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: ".5rem",
  ...yDivide,
}

export const addSectionButton = {
  width: "20rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "20px",
  gap: ".5rem",
  position: "sticky",
  top: "70px",
}

export const plusButton = {
  padding: "0px",
  width: "2rem",
  height: "2rem",
  fontSize: "1.4rem",
  color: "#B9B9C4",
}

export const customScrollColumn = {
  padding: "20px",
  paddingTop: "0px",
  position: "relative",
  scrollbarWidth: "thin",
  minHeight: "15rem",
  height: "calc(100vh - 180px)",
}

export const columnWrapper = {
  backgroundColor: "#fafafb",
  //zIndex: "105",
  width: "20rem",
  minWidth: "20rem",
  minHeight: "30rem",
  borderRadius: "0.625rem",
  outline: "none",
}

export const stickyHeader = {
  width: "100%",
  backgroundColor: "#fafafb",
  //zIndex: "101",
  position: "sticky",
  top: "-10px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px",
  borderTopRightRadius: "0.625rem",
  borderTopLeftRadius: "0.625rem",
}
